export function normalizeAgentDisplayName(
  rawName: string | null | undefined,
): string | null {
  if (!rawName) {
    return rawName ?? null;
  }

  const name = rawName.trim();
  const lower = name.toLowerCase();

  // Mapear nombres legacy "Experto" a los nuevos nombres de agentes de Ardia
  if (lower === 'experto fiscal' || lower === 'experto financiero') {
    return 'Agente Financiero / Fiscal';
  }

  if (lower === 'experto comercial' || lower === 'experto clientes') {
    return 'Agente Ventas / Clientes';
  }

  // Mantener el resto tal cual
  return name;
}

